import React from 'react';
import { DateTime } from 'luxon';
import HtmlBox from '../../../component_library/components/HtmlBox';
import type { ILoginFormDobData } from '../../../dotcms/dotcms-models/dotcms-login-form-dob';
import type { ITheme } from '../../../component_library/styles/theme';
import { DatePicker } from '../../../component_library/components/DateInput';
import type { IPropsWithTestId } from '../../../constants/data-element-tracking-ids';

interface IProps extends IPropsWithTestId {
  id?: string;
  dob: DateTime | null;
  setDob: (value: DateTime | null) => void;
  setDobValidationError: (value: string | null) => void;
  showError: boolean;
  data: ILoginFormDobData;
  theme: ITheme;
}

export const LoginDobFormDate: React.FC<IProps> = ({
  id = 'login-dob',
  dataElementId,
  dob,
  setDob,
  setDobValidationError,
  showError,
  data,
  theme,
}) => {
  const dobMinDate = DateTime.fromObject({ year: 1900, month: 1, day: 1 });
  const dobMaxDate = DateTime.now();

  return (
    <DatePicker
      id={id}
      dataElementId={dataElementId}
      label={<HtmlBox html={data.dobFieldName} />}
      value={dob}
      onChange={setDob}
      onError={setDobValidationError}
      customError={showError && <HtmlBox html={data.dobFieldError} />}
      showOpenPicker
      dateInterval={{
        minAllowedDate: dobMinDate,
        maxAllowedDate: dobMaxDate,
      }}
      theme={theme}
      fullWidth
    />
  );
};
